import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ArrowForwardIcon from '@src/componentsNew/Icons/Icons/ArrowForwardIcon';
import Typography from '@src/componentsNew/Typography/Typography';
import Button from '@src/componentsNew/Buttons/Button';

import './product-list-tile-style.scss';

import { DeviceContext, deviceType } from '@providers';
import { TypographyVariant, TypographyComponent } from '@src/utils/types';
import { goToUrl } from '@src/utils/urlCheck';

interface IProps {
  title: string;
  typoVariant: TypographyVariant;
  typoComponent: TypographyComponent;
  typoColor?: string;
  url?: any;
  isShowLine?: boolean;
  isShowBottomLine?: boolean;
  lineColor?: string;
  isShowRightBtn?: boolean;
  isShowArrow?: boolean;
  rightBtnSize?: 'small' | 'medium' | 'large';
  rightBtnText?: string;
  rightBtnColor?: string;
  rightBtnClick?: any;
  cName?: string;
}

const ProductListTitle = ({
  title,
  typoVariant,
  typoComponent,
  typoColor,
  url,
  isShowLine,
  isShowBottomLine,
  lineColor,
  isShowRightBtn,
  isShowArrow,
  rightBtnSize,
  rightBtnText,
  rightBtnColor,
  rightBtnClick,
  cName,
}: IProps) => {
  const history = useHistory();
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <div
      className={`product-list-title ${cName ? cName : ''} ${isShowLine ? 'line' : ''} ${
        isShowBottomLine ? 'bottom-line' : ''
      }`}
    >
      <Typography
        variant={typoVariant}
        component={typoComponent}
        style={{ color: typoColor ? typoColor : '#090A0FDE' }}
      >
        {title}
      </Typography>

      {isShowLine ? <div className="title-line" style={{ background: lineColor ? lineColor : '#666666' }} /> : null}

      {isShowRightBtn && (
        <Button
          size={rightBtnSize ? rightBtnSize : isMobile ? 'small' : 'large'}
          style={{ color: rightBtnColor ? rightBtnColor : '#FF3399' }}
          onClick={rightBtnClick ? rightBtnClick : () => goToUrl(history, url)}
          endIcon={isShowArrow ? <ArrowForwardIcon fillColor={rightBtnColor ? rightBtnColor : '#666666'} /> : null}
        >
          {rightBtnText ?? 'See All'}
        </Button>
      )}
    </div>
  );
};

export default ProductListTitle;
